<template>
  <div class="hierarchical-radio-list">
    <div class="scrollable-container">
      <div v-for="(category, categoryIndex) in categories" :key="categoryIndex" class="category-container">
        <div class="category-title">{{ category.title }}</div>
        <div class="items-container">
          <div v-for="(item, itemIndex) in category.items" :key="itemIndex" class="item-container">
            <input 
              type="radio" 
              :id="`${id}-${categoryIndex}-${itemIndex}`" 
              :name="id" 
              :value="item.value" 
              :checked="modelValue === item.value"
              @change="onChange(item.value)"
            />
            <label :for="`${id}-${categoryIndex}-${itemIndex}`">{{ item.label }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormHierarchicalRadioList',
  props: {
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    categories: {
      type: Array,
      required: true,
    }
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    onChange(value) {
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    }
  }
}
</script>

<style scoped>
.hierarchical-radio-list {
  border: 2px solid #195983;
  border-radius: 4px;
  background-color: #FFF;
  width: 100%;
  max-width: 390px;
}

.scrollable-container {
  max-height: 600px;
  overflow-y: auto;
  padding: 10px;
}

.category-container {
  margin-bottom: 10px;
}

.category-title {
  font-weight: 700;
  margin-bottom: 5px;
}

.items-container {
  font-weight: 700;
  padding-left: 15px;
}

.item-container {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.item-container input[type="radio"] {
  margin-right: 5px;
}

.item-container label {
  cursor: pointer;
}

/* Scrollbar styling */
.scrollable-container::-webkit-scrollbar {
  width: 8px;
}

.scrollable-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.scrollable-container::-webkit-scrollbar-thumb {
  background: #195983;
  border-radius: 4px;
}

.scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #0d4b6f;
}
</style>
